var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.13 56.23",
    width: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.13,
    d: "M53.57,40.83v7.69c.01,2.83-2.28,5.14-5.11,5.15-.16,0-.32,0-.48-.02-7.89-.86-15.47-3.55-22.13-7.87-6.2-3.94-11.45-9.19-15.39-15.39C6.12,23.7,3.43,16.08,2.59,8.16c-.25-2.82,1.83-5.31,4.65-5.57,.15-.01,.3-.02,.46-.02h7.69c2.57-.03,4.77,1.86,5.13,4.41,.32,2.46,.93,4.88,1.8,7.21,.7,1.87,.25,3.99-1.15,5.41l-3.26,3.26c3.65,6.42,8.97,11.74,15.39,15.39l3.26-3.26c1.42-1.41,3.54-1.86,5.41-1.15,2.33,.87,4.74,1.47,7.21,1.8,2.58,.36,4.48,2.6,4.41,5.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c3a9d75768ea4eeab01393dbcd743c7a.svg";
export { ForwardRef as ReactComponent };